import React, { useEffect, useRef, useState } from 'react';
import { Header } from '../../Auth/Components/Nav/Header';
import { VerticalSidebar } from '../../Auth/Components/Nav/VerticalSidebarDesign';
import { CheckMobile } from "../Helpers/CheckMobile";
import { Row } from "reactstrap";
import Footer from "../../Auth/Components/Nav/Footer";
import { MobileNav } from '../../Auth/Components/Nav/MobileNav';
import { HeaderProvider } from '../../Auth/Components/Nav/HeaderContext';
import { useLocation } from 'react-router-dom';

export function Main({ children }) {
  // 2. Obtén la ubicación actual
  const location = useLocation(); 
  
  // 3. Define la condición (evalúa si estás en alguna de las dos rutas)
  const isProceedingRoute = 
    location.pathname === '/report-proceeding-list' || 
    location.pathname === '/report-proceeding-list/report-proceeding-create' ||
    location.pathname === '/admin/guide-list';

  // 4. Determina la clase dinámica
  const backgroundClass = isProceedingRoute ? 'bg-main-proceedings' : 'bg-main';

  const [headerTitle, setHeaderTitle] = useState('Dashboard');
  const windowWidth = CheckMobile(998);
  const compactViewport = CheckMobile(1106);
  const compactDesktop = !windowWidth && compactViewport;
  const [elementHeight, setElementHeight] = useState(0);
  const [anyPanelOpen, setAnyPanelOpen] = useState(false);
  const [forceHidden, setForceHidden] = useState(false);

  useEffect(() => {
    const handler = (e) => setForceHidden(e.detail.hidden);
    window.addEventListener('mobileNavForceHide', handler);
    return () => window.removeEventListener('mobileNavForceHide', handler);
  }, []);

  useEffect(() => {
    const initialCheck = () => {
        const sidebarElement = document.getElementById('testId');
        if (sidebarElement) {
          setElementHeight(sidebarElement.offsetHeight)
        }
    }
    initialCheck();
  }, [children]);

  useEffect(() => {
    const handler = (e) => setAnyPanelOpen(e.detail.open);
    window.addEventListener('slidePanelChange', handler);
    return () => window.removeEventListener('slidePanelChange', handler);
  }, []);

  useEffect(() => {
    if (!windowWidth) return;

    const rafId = window.requestAnimationFrame(() => {
      const tabBar = document.querySelector('.mobileNavTabBar');
      const spacer = document.querySelector('.mobileNavSpacer');

      if (tabBar) {
        tabBar.classList.remove('mobileNavTabBarHidden');
      }

      if (spacer) {
        spacer.classList.remove('mobileNavSpacerHidden');
      }
    });

    return () => window.cancelAnimationFrame(rafId);
  }, [windowWidth, anyPanelOpen, forceHidden]);

  /*const pageHeight = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight
  );*/

  /*useEffect(() => {
    const sidebarElementTest = document.getElementById('sideBar');
    if (sidebarElementTest) {
      setElementHeightTest(sidebarElementTest.offsetHeight)
    }
  },[])*/

 // console.log('elementHeightTest',elementHeightTest)
  /*useEffect(() => {
    const initialCheck = () => {
      const elementContainer = document.getElementById('layout-wrapper');
      if (elementContainer) {
        setElementHeightContainer(elementContainer.offsetHeight)
      }
    }
    initialCheck();
  }, [elementHeightContainer]);*/

  return (
    <HeaderProvider>
      <div className={`container-fluid p-0 ${backgroundClass} vw-100`}>
        <div id="layout-wrapper" className="bg-darkBlue">
          <Header title={headerTitle} />
          {!windowWidth && <VerticalSidebar />}
          {windowWidth && <MobileNav />}
          <div id="contentId" className={`main-content pb-0 px-0 ${backgroundClass} ${windowWidth ? 'main-content-mobile' : ''}`}>
            <div className={`page-content pt-4 px-3 px-lg-5 ${compactDesktop ? 'page-content-compact-desktop' : ''}`}>
              <Row id="testId" className={`${windowWidth ? 'pt-1 mt-0 pb-4' : 'pt-4'} px-2 px-lg-0`}>
                {children}
              </Row>
            </div>
            {!windowWidth && <Footer />}
          </div>

        </div>
      </div>
    </HeaderProvider>
  );
}
